/**
 * Asynchronously loads the component for PiecripMembershipTierPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripMembershipTierPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripMembershipTierPage
);

